import * as swcHelpers from '@swc/helpers';
import { mapProductTypeToProductCategory, formatPrice, mapProductStockToProductStatus } from '@grandvisionhq/svc-tealium/utils';

const getFinalStockCount = (availability)=>{
    return availability ? Object.entries(availability.channels).reduce((prev, next)=>{
        return prev + next[1].availableQuantity;
    }, 0) : 0;
};
const mapVisualLineItemProductToTealiumProduct = (lineItems, withIndex)=>{
    const products = {};
    lineItems.forEach((lineItem, index)=>{
        var ref, ref1, ref2;
        const productKey = withIndex ? `${lineItem.sku}#${index}` : lineItem.sku;
        const stockCount = getFinalStockCount(lineItem.availability);
        products[productKey] = swcHelpers.objectSpread({
            Category: mapProductTypeToProductCategory(lineItem.productType)
        }, lineItem.productType == 'prescription-glasses' ? {
            FrameType: 'CP'
        } : {}, lineItem.productType == 'prescription-glasses' ? {
            LensType: 'RX'
        } : {}, {
            Price: formatPrice(((ref = lineItem.unitPrice) === null || ref === void 0 ? void 0 : ref.price) || 0, false),
            PriceFull: formatPrice(((ref1 = lineItem.unitPrice) === null || ref1 === void 0 ? void 0 : ref1.originalPrice) || 0, false),
            ModelName: `${lineItem.displayName}`,
            Status: mapProductStockToProductStatus(stockCount, true),
            TaxRate: formatPrice(((ref2 = lineItem.unitPrice) === null || ref2 === void 0 ? void 0 : ref2.tax) || 0, false),
            Units: `${lineItem.quantity.split(':')[1]}`
        });
    });
    return products;
};
const mapLineItemProductToTealiumProduct = (lineItems, withIndex)=>{
    const products = {};
    lineItems.map((lineItem, index)=>{
        const key = lineItem.type == 'prescription-glasses' ? lineItem.frame.sku : lineItem.sku;
        const stockCount = getFinalStockCount(lineItem.availability);
        products[withIndex ? `${key}#${index}` : key] = swcHelpers.objectSpread({
            Category: lineItem.productType === 'Frames' ? mapProductTypeToProductCategory(lineItem.productType.toLocaleLowerCase()) : mapProductTypeToProductCategory(lineItem.type)
        }, lineItem.type == 'prescription-glasses' ? {
            LensType: 'RX'
        } : {}, {
            FrameType: lineItem.type == 'prescription-glasses' ? 'CP' : undefined,
            Price: formatPrice(lineItem.price.unit.gross, false),
            PriceFull: formatPrice(lineItem.price.unit.original, false),
            ModelName: `${lineItem.name}`,
            Status: mapProductStockToProductStatus(stockCount, true),
            Units: `${lineItem.quantity}`,
            TaxRate: formatPrice(lineItem.price.unit.taxAmount, false)
        });
    });
    return products;
};
const mapRemovedProductToTealiumProduct = (lineItem)=>{
    const key = lineItem.type == 'prescription-glasses' ? lineItem.frame.sku : lineItem.sku;
    return {
        [key]: swcHelpers.objectSpread({
            Category: lineItem.productType === 'Frames' ? mapProductTypeToProductCategory(lineItem.productType.toLocaleLowerCase()) : mapProductTypeToProductCategory(lineItem.type)
        }, lineItem.type == 'prescription-glasses' ? {
            LensType: 'RX'
        } : {}, {
            FrameType: lineItem.type == 'prescription-glasses' ? 'CP' : undefined
        })
    };
};

export { getFinalStockCount, mapLineItemProductToTealiumProduct, mapRemovedProductToTealiumProduct, mapVisualLineItemProductToTealiumProduct };
//# sourceMappingURL=line-item-to-tealium-product.js.map
